import * as Yup from 'yup';
import {
  CasLoaderWithBackdrop,
  CasReactHookFormDialog,
  CasRHFMultilineTextField,
} from 'src/compass/shared/components';

import useUpdateMutation from 'src/compass/shared/hooks/reactQuery/useUpdateMutation';
import { onSuccessEnqueueSnackbar } from 'src/compass/shared/util/onSuccessEnqueueSnackbar';
import { IGeneralObjectType } from 'src/compass/site/util';
import { useRetrieveDetailsById } from 'src/compass/shared/hooks/reactQuery/useRetrieveDetailsById';
import { getMaxStringSchema } from 'src/compass/shared/schemas';

export const NotesSchema = Yup.object().shape({
  notes: getMaxStringSchema(),
});

export type ClaimEditNotesDialogProps = {
  label: string;
  id: number;
  url: string;
  onClose: VoidFunction;
  onUpdated: Function;
};

export default function ClaimEditNotesDialog({
  label,
  id,
  url,
  onClose,
  onUpdated,
}: ClaimEditNotesDialogProps) {
  const { data, isFetching, isError } = useRetrieveDetailsById({ entity: url, id });

  const { mutate } = useUpdateMutation({
    url,
    onSuccess: (response) => {
      onSuccessEnqueueSnackbar(response);
      onUpdated();
      onClose();
    },
  });

  const onSubmit = (payload: IGeneralObjectType) => mutate(payload);

  if (isFetching) return <CasLoaderWithBackdrop />;

  if (isError) throw new Error('Error retrieving data from the server.');

  return (
    <CasReactHookFormDialog
      open
      title={`Edit ${label}`}
      submitButtonLabel="Save"
      defaultValues={data}
      onClose={onClose}
      onSubmit={onSubmit}
      schema={NotesSchema}
    >
      <CasRHFMultilineTextField label={label} name="notes" />
    </CasReactHookFormDialog>
  );
}
